<script lang="ts">
  import ListBuilderInFullScreenModal from "@retailer/svelte/ListBuilder/Containers/ListBuilderInFullScreenModal.svelte";
  import { trackListAdd, trackListRemove } from "@shared/services/event_tracking/list_tracking";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import * as _ from "lodash";

  export let list;
  export let showListBuilder;
  export let callbacks;

  export let scope: any;
  let changedList = true;
  let isMakingApiCall = false;

  scope.initialStateForListBuilder = function () {
    scope.listBuilderState = {
      placeholderProduct: null,
      search: { query: null },
      productPicker: null,
      newProduct: null,
    };
    scope.list = list;
  };
  scope.initialStateForListBuilder();

  scope.onProductLineSearch = function (query, distributorId) {
    scope.listBuilderState.search = { query: query };
    scope.debouncedProductLineSearch(scope.listBuilderState.search.query, distributorId);
  };

  scope.massageProductLineResponse = function (products) {
    var data = [];
    for (var i = 0; i < products.length; i++) {
      var row = {
        product_line: products[i],
        distributor: {
          id: products[i].distributor_id,
          name: products[i].distributor_name,
        },
      };
      data.push(row);
    }
    return data;
  };

  scope.productLineSearch = function (query, distributorId) {
    if (!query) {
      return;
    }
    const params = { search: query, include_distributors: true };
    if (distributorId != null) {
      params["distributor_id"] = [distributorId];
    }
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/product_lines",
      data: params,
    }).then(
      function (res) {
        var query = params.search;
        if (query != scope.listBuilderState.search.query) {
          return;
        }
        var products = scope.massageProductLineResponse(res);
        scope.listBuilderState.search = Object.assign({}, scope.listBuilderState.search, {
          results: products,
        });
        updateSvelte();
      },
      function (res) {
        console.error("Unknown search error.");
      },
    );
  };
  scope.debouncedProductLineSearch = _.debounce(scope.productLineSearch, 250);

  function loadProductTabs(productLine) {
    scope.listBuilderState.productPicker = {
      productLine: productLine,
      isLoadingProductLineDetails: true,
    };
    setApiState(true);

    HttpPromise({
      method: "GET",
      url: "/api/retailer/product_lines/" + productLine.id,
    }).then(
      function (res) {
        var rawProducts = res.products;
        var containerTypeGroups = _.groupBy(rawProducts, function (p) {
          return p.container_type;
        });
        setApiState(false);
        scope.listBuilderState.productPicker = {
          cans: containerTypeGroups.can || [],
          bottles: containerTypeGroups.bottle || [],
          kegs: containerTypeGroups.keg || [],
          boxes: containerTypeGroups.box || [],
          packages: containerTypeGroups.package || [],
          items: containerTypeGroups.item || [],
          products: rawProducts,
          productLine: productLine,
          isLoadingProductLineDetails: false,
        };
        updateSvelte();
      },
      function (res) {
        console.error("Unknown search error.");
      },
    );
  }

  scope.onChooseProductSize = function (productLine) {
    loadProductTabs(productLine);
  };

  scope.onGoBackToProductLineResults = function () {
    scope.listBuilderState.productPicker = null;
    scope.listBuilderState.newProduct = null;
  };

  scope.onProductPickerTabChange = function (newTab) {
    scope.listBuilderState.productPicker = Object.assign({}, scope.listBuilderState.productPicker, {
      activeTab: newTab,
    });
    updateSvelte();
  };

  scope.onAddAnotherProduct = function () {
    scope.initialStateForListBuilder();
    updateSvelte();
  };

  function setApiState(status) {
    isMakingApiCall = status;
  }

  function updateSvelte() {
    scope = scope;
  }

  function apiCallToAddSomethingToList(data, completed) {
    setApiState(true);
    HttpPromise({
      method: "POST",
      url: "/api/retailer/quick_order_lists/" + list.id + "/products",
      data: data,
    }).then(
      function (res) {
        setApiState(false);
        scope.list = res;
        updateSvelte();
        completed();
      },
      function (res) {
        setApiState(false);
        console.error("Unknown error.");
        completed();
        // TODO: Maybe show message?
      },
    );
  }

  scope.onAddProductToList = function (product, placeholderProduct) {
    var data = { product_id: product.id, inventory_id: product.inventory_id };
    if (placeholderProduct != null) {
      data["quick_order_list_product_placeholder_id"] = placeholderProduct.id;
      scope.listBuilderState.placeholderProduct = null;
    }

    apiCallToAddSomethingToList(data, function () {
      trackListAdd(list.id, product.id, null, product.inventory_id, null);
    });

    changedList = true;
  };

  scope.onAddProductLinePlaceholder = function (productLine) {
    var data = { placeholder_product_line_id: productLine.id };

    apiCallToAddSomethingToList(data, function () {
      trackListAdd(list.id, null, productLine.id, null, null);
    });

    changedList = true;
  };

  scope.onRemoveProductLinePlaceholder = function (quickOrderListProductId) {
    setApiState(true);
    HttpPromise({
      method: "DELETE",
      url: "/api/retailer/quick_order_lists/" + list.id + "/products/" + quickOrderListProductId,
    }).then(
      function (res) {
        setApiState(false);
        scope.list = res;
        updateSvelte();
        // listId, productId, productLineId, inventoryId, distributorId
        trackListRemove(list.id, quickOrderListProductId, null, null, null);

        changedList = true;
      },
      function (res) {
        console.error("Unknown error.");
        setApiState(false);
      },
    );
  };

  scope.onRemoveProductFromListTemp = function (product) {
    setApiState(true);

    HttpPromise({
      method: "DELETE",
      url: "/api/retailer/quick_order_lists/" + list.id + "/products/destroy_by_product_id",
      data: {
        quick_order_list_product: {
          product_id: product.id,
          inventory_id: product.inventory_id,
        },
      },
    }).then(
      function (res) {
        scope.list = res;
        updateSvelte();
        setApiState(false);
        // listId, productId, productLineId, inventoryId, distributorId
        trackListRemove(list.id, product.id, null, product.inventory_id, null);
      },
      function (res) {
        console.error("Unknown error.");
        // TODO: Maybe show message?
        setApiState(false);
      },
    );
  };

  scope.onCreateNamedPlaceholder = function (name, distributorId) {
    var data = {
      placeholder_product_name: name,
      placeholder_distributor_id: distributorId,
    };
    apiCallToAddSomethingToList(data, function () {
      scope.listState.showListBuilder = false;
      // listId, productId, productLineId, inventoryId, distributorId
      trackListAdd(list.id, null, null, null, distributorId);
    });
  };

  scope.svelteCloseCallback = function () {
    scope.initialStateForListBuilder();
    callbacks.closeListBuilder(changedList);
  };
</script>

<ListBuilderInFullScreenModal
  list={scope.list}
  placeholderProduct={scope.listBuilderState.placeholderProduct}
  isVisible={showListBuilder}
  {isMakingApiCall}
  search={scope.listBuilderState.search}
  productPicker={scope.listBuilderState.productPicker}
  newProduct={scope.listBuilderState.newProduct}
  svelteCloseCallback={scope.svelteCloseCallback}
  onProductLineSearch={scope.onProductLineSearch}
  onChooseProductSize={scope.onChooseProductSize}
  onAddProductLinePlaceholder={scope.onAddProductLinePlaceholder}
  onRemoveProductLinePlaceholder={scope.onRemoveProductLinePlaceholder}
  onGoBackToProductLineResults={scope.onGoBackToProductLineResults}
  onAddProductToList={scope.onAddProductToList}
  onRemoveProductFromList={scope.onRemoveProductFromListTemp}
  onProductPickerTabChange={scope.onProductPickerTabChange}
  onAddAnotherProduct={scope.onAddAnotherProduct}
  onCreateNamedPlaceholder={scope.onCreateNamedPlaceholder}
/>
